import type * as Types from 'app/types/graphql';

import { ClickMapPointSelectFragmentDoc } from '../fragments/clickMapPoint.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type HeatmapClicksQueryVariables = Types.Exact<{
  where: Types.HeatmapClicksWhereInput;
}>;

export type HeatmapClicksQueryResponse = {
  heatmapClicks: Array<
    Pick<
      Types.ClickMapPoint,
      'hash' | 'elementSelector' | 'x' | 'y' | 'clicks' | 'points' | 'totalClicks'
    >
  >;
};

export const HeatmapClicksDocument = `
    query HeatmapClicks($where: HeatmapClicksWhereInput!) {
  heatmapClicks(where: $where) {
    ...ClickMapPointSelect
  }
}
    ${ClickMapPointSelectFragmentDoc}`;

export const useHeatmapClicksQuery = <TData = HeatmapClicksQueryResponse, TError = unknown>(
  variables: HeatmapClicksQueryVariables,
  options?: UseQueryOptions<HeatmapClicksQueryResponse, TError, TData>,
) => {
  return useQuery<HeatmapClicksQueryResponse, TError, TData>(
    ['HeatmapClicks', variables],
    appFetcher<HeatmapClicksQueryResponse, HeatmapClicksQueryVariables>(
      HeatmapClicksDocument,
      variables,
    ),
    options,
  );
};

useHeatmapClicksQuery.getKey = (variables: HeatmapClicksQueryVariables) => [
  'HeatmapClicks',
  variables,
];
